export const inventoryFields = {
  hsCode: 'default_inventory_item_hs_code',
  htsCode: 'default_inventory_item_hts_code',
  midCode: 'default_inventory_item_mid_code',
  nsPid: 'default_inventory_item_ns_pid',
  countryFrom: 'default_inventory_item_country_from',
  weight: 'default_inventory_item_weight',
  weightUnit: 'default_inventory_item_weight_unit',
}
